<template>
  <section
    class="text-center mt-10 p-2"
    aria-label="Sosyal Medya Hesaplarınızı Özelleştirin"
    id="what-can-you-do"
  >
    <div class="max-w-7xl mx-auto">
      <h2 class="text-xl md:text-3xl font-bold">
        <span class="text-orange-500">Sosyal medya hesaplarınızı</span> esnek
        hizmetlerler özelleştirin
      </h2>
      <p class="text-xs text-slate-600 mt-2">
        Sosyal Medya Hesaplarınızı İster Aylık İster Anlık Hizmetlerle
        Dilediğiniz Gibi Özelleştirin
      </p>
      <div
        class="max-w-5xl mx-auto grid grid-cols-1 gap-6 mt-6"
        aria-label="Sosyal Medya Otomatik ve Organik Etkileşim Aracı"
      >
        <FlexibleItem
          icon="fluent:star-emphasis-20-filled"
          title="Otomatik Etkileşim Aracı"
          titleDescription="Otomatik ve Kesintisiz Etkileşim"
          :mainTexts="[
            'Bir Kez Tanımla, Sürekli Devam Et → Tek seferlik kurulumla, belirlediğiniz kriterlerde hizmet otomatik devam eder.',
            'Esnek Planlama → Siparişlerin kaç saat veya kaç gün arayla oluşturulacağını belirleyebilirsiniz.',
            'Algoritmaya Uygun İşleyiş → Sürekli ve doğal etkileşim ile keşfet algoritmanızı aktif edin.',
          ]"
          whyTitle="Otomatik Etkileşim Aracı Neden Önemli?"
          :whyTexts="[
            'Sosyal medya platformları düzenli ve doğal etkileşimi ödüllendirir. Otomatik Etkileşim Aracı sayesinde belirlediğiniz kriterlerde kesintisiz bir akış sağlarken, manuel sipariş takibine gerek kalmaz.',
            'Hesabınızın Öneriler, Trend ve Keşfet algoritmasının aktifleşmesini sağlar.',
          ]"
          videoUrl="/"
        />
        <FlexibleItem
          icon="material-symbols:charger"
          title="Organik Etkileşim Aracı"
          titleDescription="Manuel sipariş verme esnekliği"
          :mainTexts="[
            'İhtiyacınıza Göre Esnek Kullanım → Belirlediğiniz işlemleri anlık olarak oluşturun.',
            'Anlık Müdahale → Hangi içerikleriniz için ne zaman destek alacağını kendiniz belirleyin.',
            'Kendi Stratejinizi Kurun → Her siparişinizi ayrı ayrı planlayarak hedef kitlenize uygun şekilde yönetin.',
            'Kontrol Sizin Elinizde → Tüm işlemleri manuel olarak başlatıp yönetebilirsiniz.',
          ]"
          whyTitle="Gig Oluşturmak Neden Önemli?"
          :whyTexts="[
            'Tam kontrol isteyenler için ideal bir çözüm. İhtiyacınıza özel olarak etkileşim oluşturabilir, belirlediğiniz içeriklere anlık destek sağlayabilirsiniz.',
            'Stratejinizi belirleyin, yönetin ve içeriklerinizi öne çıkarın!',
          ]"
          videoUrl="/"
        />
        <FlexibleItem
          icon="bx:store"
          title="Mega Mağaza"
          titleDescription="Düşük Maliyetler ile Yüksek Hacimli Siparişler"
          :mainTexts="[
            'Geniş Kapsamlı İşlemler → Küçük limitlere takılmadan, yüksek hacimli etkileşimler sağlayın.',
            'Yüksek Limitler → Kitlenizi hızlıca milyonlara ulaştırabilir, paylaşımlarınıza yüz binlerce etkileşim sağlayabilirsiniz.',
            'Uygun Maliyetler → Büyük hacimli işlemler için bütçe dostu çözümler sunar.',
          ]"
          whyTitle="Mağaza Neden Önemli?"
          :whyTexts="[
            'Büyük ölçekli etkileşim ihtiyacınız varsa, mağaza size en yüksek hacimli çözümleri sunar.',
            'Organik Etkileşim Aracı ve Otomatik Etkileşim Aracı sistemlerinin limitleri düşükken, mağaza ile daha geniş hedeflere ulaşabilirsiniz.',
          ]"
          videoUrl="/"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import FlexibleItem from './FlexibleItem.vue'
</script>
